module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Seattle Neighborhoods")]), _vm._v(" "), _c('ul', {
    staticClass: "l-grid l-grid-xsmall"
  }, _vm._l((_vm.neighborhoods), function(neighborhood) {
    return _c('li', [_c('router-link', {
      staticClass: "mini-card",
      attrs: {
        "to": {
          name: 'neighborhood',
          params: {
            id: neighborhood.slug
          }
        }
      }
    }, [_vm._v(_vm._s(neighborhood.name))])], 1)
  })), _vm._v(" "), _c('Geo', {
    attrs: {
      "multipolygons": _vm.multipolygons
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d4a2b95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Neighborhoods.vue
// module id = 477
// module chunks = 1